const items = [
  "VERIFIED IN PRODUCTION",
  "REAL DEPLOYMENTS",
  "PEER-LED INTELLIGENCE",
  "NO VENDOR FLUFF",
  "WHAT ACTUALLY WORKS",
  "CUSTOMER-CONFIRMED",
  "SIGNAL OVER NOISE",
  "SHIPPED, NOT PITCHED",
];

export default function StatusTicker() {
  const loop = [...items, ...items];
  return (
    <div
      data-testid="status-ticker"
      className="relative z-10 mt-10 overflow-hidden border-y border-zinc-200 bg-white/60 py-4"
    >
      <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap font-mono-tech text-[11px] uppercase tracking-[0.32em] text-zinc-500">
        {loop.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-12">
            <span className="inline-flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-[#00D752] shadow-[0_0_8px_rgba(0,215,82,0.6)]" />
              {t}
            </span>
            <span className="text-zinc-300">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
